module.exports = __webpack_public_path__ + "img/img2.1a01ccc5.png";